import { IconProps } from '~/components/Icon/Icon';

export const Boost2D = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.97054 2.85712C6.82797 2.85712 6.70747 2.96275 6.6888 3.10409L5.71685 10.4626C5.69436 10.6328 5.82685 10.784 5.99859 10.784H8.28864L7.77475 16.8484C7.7607 17.0142 7.8915 17.1565 8.05792 17.1565H9.55827C9.6565 17.1565 9.74776 17.1058 9.79962 17.0224L14.9139 8.79618C15.0315 8.60688 14.8954 8.36195 14.6725 8.36195H11.8085L13.6229 3.23613C13.6884 3.05119 13.5512 2.85712 13.355 2.85712H6.97054Z"
      fill="#29CEEE"
    />
  </svg>
);
